import gql from "graphql-tag";

export const orderMailLogsFragments = gql`
  fragment orderMailLogsFragments on LogOrderMail {
    id pdfType recipientMail sentAt
    sentBy { id name }
    deliveryStatus
    deliveryError
  }
`;